import React from 'react';
import './PasswordStrengthIndicator.css';

const PasswordStrengthIndicator = ({ password, language = 'en' }) => {
  const calculateStrength = (pwd) => {
    if (!pwd) return { score: 0, label: '', color: '' };
    
    let score = 0;
    
    // Length check
    if (pwd.length >= 8) score++;
    if (pwd.length >= 12) score++;
    
    // Character variety
    if (/[a-z]/.test(pwd)) score++; // lowercase
    if (/[A-Z]/.test(pwd)) score++; // uppercase
    if (/[0-9]/.test(pwd)) score++; // numbers
    if (/[^a-zA-Z0-9]/.test(pwd)) score++; // special chars
    
    // Determine strength
    if (score <= 2) {
      return {
        score: 1,
        label: language === 'de' ? 'Schwach' : 'Weak',
        color: '#ff4444'
      };
    } else if (score <= 4) {
      return {
        score: 2,
        label: language === 'de' ? 'Mittel' : 'Medium',
        color: '#ff9800'
      };
    } else {
      return {
        score: 3,
        label: language === 'de' ? 'Stark' : 'Strong',
        color: '#4caf50'
      };
    }
  };
  
  const strength = calculateStrength(password);
  
  if (!password) return null;
  
  return (
    <div className="password-strength-indicator">
      <div className="strength-bars">
        {[1, 2, 3].map((bar) => (
          <div
            key={bar}
            className={`strength-bar ${bar <= strength.score ? 'active' : ''}`}
            style={{ backgroundColor: bar <= strength.score ? strength.color : '#e0e0e0' }}
          />
        ))}
      </div>
      <span className="strength-label" style={{ color: strength.color }}>
        {strength.label}
      </span>
      {strength.score < 3 && (
        <p className="strength-hint">
          {language === 'de' 
            ? 'Mindestens 8 Zeichen, Groß-/Kleinbuchstaben, Zahlen und Sonderzeichen empfohlen'
            : 'At least 8 characters, uppercase, lowercase, numbers, and special characters recommended'}
        </p>
      )}
    </div>
  );
};

export default PasswordStrengthIndicator;
